import * as _ from 'lodash';
import { Component, computed, effect, inject, signal } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';

import { DomainPageService } from 'src/app/features/domain/services/domain-page.service';
import { AccountPageService } from 'src/app/features/user-account/services/account-page.service';
import { SharedModule } from '../../shared.module';
import { ButtonNavigationComponent } from '../../controls/container/button-navigation/button-navigation.component';
import { IconsModule } from '../../icons/icons.module';
import { LogoHeaderComponent } from '../../image-boxes/logo-header/logo-header.component';
import { headerData } from '../models/header-data';
import { DomainProfileService } from 'src/app/infrastructure/services/domain-profile-services/domain-profile.service';
import { domainProfile } from 'src/app/infrastructure/services/domain-profile-services/models/domain-profile-data';
import { HeaderStorageService } from '../../storage/services/storage-services/header-storage-service';
import { ApplicationUserService } from 'src/app/infrastructure/services/application-user.services/application-user.service';
import { ChatPollingService } from 'src/app/features/chat/services/chat-polling.service';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';
import { routePage } from 'src/app/infrastructure/services/route-service/models/route-page';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    host: {
        class: 'header'
    },
    standalone: true,
    imports: [
        SharedModule,
        ButtonNavigationComponent,
        IconsModule,
        LogoHeaderComponent,
        MatMenuModule,
        MatDividerModule,
    ],
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

    // @HostBinding() class = 'header';

    private readonly __domainProfileService = injectRequired(DomainProfileService);
    private readonly __accountPageService = injectRequired(AccountPageService);
    private readonly __applicationUserService = injectRequired(ApplicationUserService);
    private readonly __chatPollingService = injectRequired(ChatPollingService);
    private readonly __headerStorageService = injectRequired(HeaderStorageService);
    private readonly __domainPageService = inject(DomainPageService, {optional: true});
    
    private readonly __headerData$$ = this.__headerStorageService.headerData$$;
    private readonly __profileData$$ = this.__domainProfileService.profileData$$;
    private readonly __logoThumbUrl$$ = this.__domainProfileService.logoThumb_url$$;

    domain_name$$ = computed(() => this.__profileData$$()?.[domainProfile.title] ?? null);
    accountEmail$$ = this.__applicationUserService.accountEmail$$;
    chatUnread$$ = this.__chatPollingService.unreadCount$$;
    logoThumb_url$$ = computed(() => this.__logoThumbUrl$$() ?? null);
    noClick$$ = computed(() => this.__headerData$$()?.[headerData.sideBlockLeft_noClick] ?? null);
    sideBlockLeft_hide$$ = computed(() => this.__headerData$$()?.[headerData.sideBlockLeft_hide] ?? null);
    sideBlockRight_hide$$ = computed(() => this.__headerData$$()?.[headerData.sideBlockRight_hide] ?? null);
    subTitle$$ = computed(() => this.__headerData$$()?.[headerData.subTitle] ?? null);
    subTitle_hide$$ = computed(() => this.__headerData$$()?.[headerData.subTitle_hide] ?? null);
    title$$ = computed(() => this.__headerData$$()?.[headerData.title] ?? null);

    readonly text = {
        chats: 'Chats',
    };

    logOut() {
        this.__accountPageService.logOut();
    }

    gotoEmailChange() {
        this.__accountPageService.page_goto(routePage.emailChange);
    }

    gotoHome() {
        this.__accountPageService.pageRoute_goto();
    }

    gotoPasswordChange() {
        this.__accountPageService.page_goto(routePage.passwordChange);
    }

    gotoSettings() {
        this.__accountPageService.page_goto(routePage.settings);
    }

    onLogoClick() {
        this.__domainPageService?.pageRoute_goto();
    }
}
